window.VegasCatalog.Cart = {
	add: function (id, cnt, params, callback) {
		params = params || {};
		params.id = id;
		params.cnt = cnt || 1;
		params._token = App.csrf;

		this.addRequest(params, callback);
	},

	addRequest: function (params, callback) {
		$.post('/cart/add_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);
			VegasCatalog.popup('Товар добавлен в корзину');
			VegasCatalog.Cart.total(data);

			yaCounterReachGoal('add-to-cart');
		});
	},

	changeCnt: function (id, cnt, callback) {
		let params = VegasCatalog.Cart.formData({
			id: id,
			cnt: cnt,
		});

		$.post('/cart/change_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Cart.total(data);
		});
	},

	remove: function (id, callback) {
		let params = {};
		params.id = id;
		params._token = App.csrf;

		this.removeRequest(params, callback);
	},

	removeRequest: function (params, callback) {
		$.post('/cart/del_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.popup('Товар убран из корзины');
			VegasCatalog.Cart.total(data);
		});
	},

	total: function (data) {
		if (typeof data.products_count !== 'undefined') {
			$('[data-cart][data-counter=products]').attr('data-cnt', data.products_count);
		}

		this.totalCartForm(data);
	},

	totalCartForm: function (data) {
		let $form = $('#form-cart');

		if ($form.length) {
			// products sum
			let $sProducts = $form.find('[data-sum="products"]');

			$sProducts.find('[data-title]').text(
				output_wordform(data.products_valid_count, ['товар', 'товара', 'товаров'])
			);

			$sProducts.find('[data-sum-value]').text(
				output_roubles(data.sums.sum_products)
			);

			// cart sum
			let $sCart = $form.find('[data-sum="total"]');
			$sCart.find('[data-sum-value]').text(output_roubles(data.sums.sum));

			// delivery sym
			let $sDelivery = $form.find('[data-sum="delivery"]');
			if (data.sums.sum_delivery !== null) {
				$sDelivery.find('[data-sum-value]')
				.text(
					isNaN(data.sums.sum_delivery) ? data.sums.sum_delivery : (
						data.sums.sum_delivery > 0 ? output_roubles(data.sums.sum_delivery) : 'бесплатно'
					)
				);
				$sDelivery.show();
			} else {
				$sDelivery.hide();
			}
		}
	},

	updateTotalAll: function () {
		VegasCatalog.Cart.toggleSubmit(0);
		VegasCatalog.Cart.loadingSums(1);

		$.get('/cart/get_totals', VegasCatalog.Cart.formData(), function (data) {
			VegasCatalog.Cart.total(data);
			VegasCatalog.Cart.toggleSubmit(1);
			VegasCatalog.Cart.loadingSums(0);
		});
	},

	formData: function (appendParams) {
		appendParams = appendParams || {};
		let resultParams = $('#form-cart').serializeArray();

		if (!resultParams.length) {
			resultParams.push({name: '_token', value: App.csrf});
		}

		for (let name in appendParams) {
			resultParams.push({name: name, value: appendParams[name]});
		}

		return resultParams;
	},

	checkCartDisable: function (data) {
		let $form = $('#form-cart');
		if (!data.sums.sum) {
			$form.find('button[type=submit]').addClass('disabled').attr('disabled', 'disabled');
		}
	},

	toggleSubmit: function(toggle) {
		let $form = $('#form-cart');
		let $element = $form.find('button[type=submit]');
		if (toggle) {
			$element.removeAttr('disabled')
		}  else {
			$element.attr('disabled', 'disabled');
		}
	},

	loadingSums: function(show) {
		let $form = $('#form-cart');
		let $totals = $form.find('.totals-area');

		if (show) {
			$totals.addClass('loading');
		} else {
			$totals.removeClass('loading');
		}
	}
};

let $document = $(document),
	$formCart = $("#form-cart")
;

/** PRODUCT SHOW */
$document.on('click', '[data-product] [data-cart][data-action=add]', function () {
	let $product = $(this).closest('[data-product]');
	let id = $product.data('id');
	let cnt = $(this).data('cnt');
	$product.addClass('in-cart');

	VegasCatalog.Cart.add(id, cnt, {});

	return false;
});

$document.on('click', '[data-product] [data-cart][data-action=remove], [data-product] [data-qty=trash]', function () {
	let $product = $(this).closest('[data-product]');
	$product.removeClass('in-cart');

	VegasCatalog.Cart.remove($product.data('id'));

	return false;
});

$document.on('change-counter', '[data-product] [data-cart="qty"]', function () {
	let $product = $(this).closest('[data-product]');
	let id = $product.data('id');
	let cnt = $(this).find('input').val();

	VegasCatalog.Cart.changeCnt(id, cnt, function (data) {
		if (cnt <= 0) {
			$product.removeClass('in-cart');
		}
	});
});

/** LIST ITEM */
$document.on('click', '[data-product-item] [data-cart][data-action=add]', function () {
	let $product = $(this).closest('[data-product-item]');
	let $btn = $(this);
	let id = $product.data('id');
	let cnt = $product.data('cnt');

	$product.addClass('in-cart');

	VegasCatalog.Cart.add(id, cnt);

	return false;
});

$document.on('click', '[data-product-item] [data-qty=trash]', function () {
	let $product = $(this).closest('[data-product-item]');
	let $btn = $(this);
	let id = $product.data('id');

	$product.removeClass('in-cart');

	VegasCatalog.Cart.remove(id);

	return false;
});

$document.on('change-counter', '[data-product-item] [data-cart="qty"]', function () {
	let $product = $(this).closest('[data-product-item]');
	let id = $product.data('id');
	let cnt = $(this).find('input').val();

	VegasCatalog.Cart.changeCnt(id, cnt);
});

/** CART */
$document.on('change-counter', '[data-product-cart-item] [data-cart="qty"]', function () {
	let $product = $(this).closest('[data-product-cart-item]');
	let id = $product.data('id');
	let cnt = $(this).find('input').val();

	VegasCatalog.Cart.toggleSubmit(0);
	VegasCatalog.Cart.loadingSums(1);

	VegasCatalog.Cart.changeCnt(id, cnt, function (data) {
		$product.find('.price-total').html(output_money(data.price_total));

		VegasCatalog.Cart.toggleSubmit(1);
		VegasCatalog.Cart.loadingSums(0);
	});
});
$document.on('click', '[data-product-cart-item] [data-cart][data-action=del]', function () {
	let $product = $(this).closest('[data-product-cart-item]');
	let $btn = $(this);
	let id = $product.data('id');

	$product.remove();

	VegasCatalog.Cart.remove(id, function (data) {
		let len = $('.vg-catalog-cart--products [data-product-cart-item]').length;

		if (len === 0) {
			location.reload();
			return;
		}

		VegasCatalog.Cart.updateTotalAll();
	});

	return false;
});

if ($formCart.length) {
	VegasCatalog.Cart.updateTotalAll();
}
